import * as storage from '../storage'
import * as types from './mutation-types'
import * as carrinhoStorage from '@/modules/carrinho/storage'
import { normalizarEsquemaUrl } from '@/util/url'

export const ActionSetEmailUsuario = ({ commit }, emailUsuario) => {
  commit(types.SET_EMAIL_USUARIO, emailUsuario)
  storage.setEmailUsuario(emailUsuario)
}

export const ActionSetNomeEmpresa = ({ commit }, nomeEmpresa) => {
  commit(types.SET_NOME_EMPRESA, nomeEmpresa)
  storage.setNomeEmpresa(nomeEmpresa)
}

export const ActionSetIdEmpresa = ({ commit }, id) => {
  commit(types.SET_ID_EMPRESA, id)
  storage.setIdEmpresa(id)
}

export const ActionSetCpfCnpj = ({ commit }, cpfCnpj) => {
  commit(types.SET_CPF_CNPJ, cpfCnpj)
  storage.setCpfCnpj(cpfCnpj)
}

export const ActionSetRepresentanteLegal = ({ commit }, representanteLegal) => {
  const ehRepresentanteLegal = (representanteLegal === 'true' || representanteLegal === true)
  commit(types.SET_REPRESENTANTE_LEGAL, ehRepresentanteLegal)
  storage.setRepresentanteLegal(representanteLegal)
}

export const ActionSetRegrasLogin = ({ commit }, regrasLogin) => {
  commit(types.SET_REGRAS_LOGIN, regrasLogin)
  storage.setRegrasLogin(regrasLogin)
}

export const ActionSetLoginStrategy = ({ commit }, loginStrategy) => {
  commit(types.SET_LOGIN_STRATEGY, loginStrategy)
  storage.setLoginStrategy(loginStrategy)
}

export const ActionSetLogoCliente = ({ commit }, logoCliente) => {
  // Sobe http->https quando a página é https, para o logo gravado com http no
  // banco (endereco_logotipo) não ser bloqueado como conteúdo misto.
  const logoNormalizado = normalizarEsquemaUrl(logoCliente)
  commit(types.SET_LOGO_CLIENTE, logoNormalizado)
  storage.setLogoCliente(logoNormalizado)
}

export const ActionSetEscritorio = ({ commit }, escritorio) => {
  commit(types.SET_ESCRITORIO, escritorio)
  storage.setEscritorio(escritorio)
}

export const ActionSetTipoDeAcesso = ({ commit }, tipoDeAcesso) => {
  commit(types.SET_TIPO_DE_ACESSO, tipoDeAcesso)
  storage.setTipoDeAcesso(tipoDeAcesso)
}

export const ActionSetPerfilUsuario = ({ commit }, perfilUsuario) => {
  commit(types.SET_PERFIL_USUARIO, perfilUsuario)
  storage.setPerfilUsuario(perfilUsuario)
}

export const ActionSetAcessoFinanceiro = ({ commit }, temAcessoAoFinanceiro) => {
  const temAcesso = (temAcessoAoFinanceiro === 'true' || temAcessoAoFinanceiro === true)
  commit(types.SET_ACESSO_FINANCEIRO, temAcesso)
  storage.setTemAcessoAoFinanceiro(temAcessoAoFinanceiro)
}

export const ActionSetAcessoRelatorios = ({ commit }, temAcessoAosRelatorios) => {
  const temAcesso = (temAcessoAosRelatorios === 'true' || temAcessoAosRelatorios === true)
  commit(types.SET_ACESSO_RELATORIOS, temAcesso)
  storage.setTemAcessoAosRelatorios(temAcessoAosRelatorios)
}

export const ActionSetRelatoriosContratado = ({ commit }, relatoriosContratado) => {
  const temContratado = (relatoriosContratado === 'true' || relatoriosContratado === true)
  commit(types.SET_ACESSO_RELATORIOS_CONTRATADO, temContratado)
  storage.setRelatoriosContratado(relatoriosContratado)
}

export const ActionSetAcessoEscritorio = ({ commit }, temAcessoAoEscritorio) => {
  const temAcesso = (temAcessoAoEscritorio === 'true' || temAcessoAoEscritorio === true)
  commit(types.SET_ACESSO_ESCRITORIO, temAcesso)
  storage.setTemAcessoAoEscritorio(temAcessoAoEscritorio)
}

export const ActionSetFinanceiroContratado = ({ commit }, financeiroContratado) => {
  const temContratado = (financeiroContratado === 'true' || financeiroContratado === true)
  commit(types.SET_FINANCEIRO_CONTRATADO, temContratado)
  storage.setFinanceiroContratado(financeiroContratado)
}

export const ActionSetAcessoFaturamento = ({ commit }, temAcessoAoFaturamento) => {
  const temAcesso = (temAcessoAoFaturamento === 'true' || temAcessoAoFaturamento === true)
  commit(types.SET_ACESSO_FATURAMENTO, temAcesso)
  storage.setTemAcessoAoFaturamento(temAcessoAoFaturamento)
}

export const ActionSetFaturamentoContratado = ({ commit }, faturamentoContratado) => {
  const temContratado = (faturamentoContratado === 'true' || faturamentoContratado === true)
  commit(types.SET_FATURAMENTO_CONTRATADO, temContratado)
  storage.setFaturamentoContratado(faturamentoContratado)
}

export const ActionSetNomeUsuarioLogado = ({ commit }, nomeUsuarioLogado) => {
  commit(types.SET_NOME_USUARIO_LOGADO, nomeUsuarioLogado)
  storage.setNomeUsuarioLogado(nomeUsuarioLogado)
}

export const ActionSetCodigoFotoUsuario = ({ commit }, codigoFotoUsuario) => {
  commit(types.SET_CODIGO_FOTO_USUARIO, codigoFotoUsuario)
  storage.setCodigoFotoUsuario(codigoFotoUsuario)
}

export const ActionSetEscritorioInadimplente = ({ commit }, escritorioInadimplente) => {
  const escritorioEstaInadimplente = (escritorioInadimplente === 'true' || escritorioInadimplente === true)
  commit(types.SET_ESCRITORIO_INADIMPLENTE, escritorioEstaInadimplente)
  storage.setEscritorioInadimplente(escritorioEstaInadimplente)
}

export const ActionSetDadosAlertaVencimento = ({ commit }, dadosAlertaVencimento) => {
  commit(types.SET_DADOS_ALERTA_VENCIMENTO, dadosAlertaVencimento)
  storage.setDadosAlertaVencimento(dadosAlertaVencimento)
}

export const ActionSetDadosAlertaDesbloqueioEscritorio = ({ commit }, dadosAlertaDesbloqueio) => {
  commit(types.SET_DADOS_ALERTA_DESBLOQUEIO_ESCRITORIO, dadosAlertaDesbloqueio)
}

export const ActionSetIdUsuarioLogado = ({ commit }, idUsuarioLogado) => {
  commit(types.SET_ID_USUARIO_LOGADO, idUsuarioLogado)
  storage.setIdUsuarioLogado(idUsuarioLogado)
}

export const ActionSetDataCriacaoUsuarioLogado = ({ commit }, dataCriacaoUsuarioLogado) => {
  commit(types.SET_DATA_CRIACAO_USUARIO_LOGADO, dataCriacaoUsuarioLogado)
  storage.setDataCriacaoUsuarioLogado(dataCriacaoUsuarioLogado)
}

export const ActionSetSuporteOnlineHabilitado = ({ commit }, flagSuporteOnlineHabilitado) => {
  const suporteOnlineHabilitado = (flagSuporteOnlineHabilitado === 'true' || flagSuporteOnlineHabilitado === true)
  commit(types.SET_SUPORTE_ONLINE_HABILITADO, suporteOnlineHabilitado)
  storage.setSuporteOnlineHabilitado(suporteOnlineHabilitado)
}

export const ActionSetDadosCampanhaMarketing = ({ commit }, dadosCampanhaMarketing) => {
  commit(types.SET_DADOS_CAMPANHA_MARKETING, dadosCampanhaMarketing)
}

export const ActionSetOcultarOpcaoMenuBanco = ({ commit }, flagOcultarOpcaoMenuBanco) => {
  const ocultarOpcaoMenuBanco = (flagOcultarOpcaoMenuBanco === 'true' || flagOcultarOpcaoMenuBanco === true)
  commit(types.SET_OCULTAR_OPCAO_MENU_BANCO, ocultarOpcaoMenuBanco)
  storage.setOcultarOpcaoMenuBanco(ocultarOpcaoMenuBanco)
}

export const ActionSetAlertaStatusEmpresa = ({ commit }, alertaStatusEmpresa) => {
  const parsed = alertaStatusEmpresa && typeof alertaStatusEmpresa === 'string'
    ? JSON.parse(alertaStatusEmpresa)
    : alertaStatusEmpresa || null
  commit(types.SET_ALERTA_STATUS_EMPRESA, parsed)
  storage.setAlertaStatusEmpresa(JSON.stringify(parsed))
}

export const ActionSignOut = async ({ dispatch }) => {
  dispatch('ActionSetEmailUsuario', '')
  storage.deleteEmailUsuario()
  dispatch('ActionSetNomeEmpresa', '')
  storage.deleteNomeEmpresa()
  dispatch('ActionSetIdEmpresa', '')
  storage.deleteIdEmpresa()
  dispatch('ActionSetCpfCnpj', '')
  storage.deleteCpfCnpj()
  dispatch('ActionSetRepresentanteLegal', '')
  storage.deleteRepresentanteLegal()
  dispatch('ActionSetRegrasLogin', '')
  storage.deleteRegrasLogin()
  dispatch('ActionSetLoginStrategy', '')
  storage.deleteLoginStrategy()
  dispatch('ActionSetPerfilUsuario', '')
  storage.deletePerfilUsuario()
  dispatch('ActionSetTipoDeAcesso', '')
  storage.deleteTipoDeAcesso()
  dispatch('ActionSetAcessoFinanceiro', '')
  storage.deleteTemAcessoAoFinanceiro()
  dispatch('ActionSetFinanceiroContratado', '')
  storage.deleteFinanceiroContratado()
  dispatch('ActionSetAcessoFaturamento', '')
  storage.deleteTemAcessoAoFaturamento()
  dispatch('ActionSetAcessoRelatorios', '')
  storage.deleteTemAcessoAosRelatorios()
  dispatch('ActionSetAcessoEscritorio', '')
  storage.deleteTemAcessoAoEscritorio()
  dispatch('ActionSetFaturamentoContratado', '')
  storage.deleteFaturamentoContratado()
  dispatch('ActionSetRelatoriosContratado', '')
  storage.deleteRelatoriosContratado()
  storage.deleteNomeUsuarioLogado()
  dispatch('ActionSetNomeUsuarioLogado', '')
  storage.deleteNomeUsuarioLogado()
  dispatch('ActionSetCodigoFotoUsuario', '')
  storage.deleteCodigoFotoUsuario()
  dispatch('ActionSetEscritorioInadimplente', '')
  storage.deleteEscritorioInadimplente()
  dispatch('ActionSetDadosAlertaVencimento', '')
  storage.deleteDadosAlertaVencimento()
  dispatch('ActionSetDadosAlertaDesbloqueioEscritorio', '')
  dispatch('carrinho/ActionLimparDadosCarrinho', null, { root: true })
  dispatch('carrinho/ActionLimparCupomDataDoCarrinho', null, { root: true })
  carrinhoStorage.deleteItensCarrinho()
  carrinhoStorage.deleteCupomCarrinho()
  storage.deleteIdUsuarioLogado()
  dispatch('ActionSetIdUsuarioLogado', '')
  storage.deleteDataCriacaoUsuarioLogado()
  dispatch('ActionSetDataCriacaoUsuarioLogado', '')
  dispatch('ActionSetSuporteOnlineHabilitado', '')
  storage.deleteSuporteOnlineHabilitado()
  dispatch('filtros/ActionLimparFiltros', null, { root: true })
  dispatch('ActionSetOcultarOpcaoMenuBanco', false)
  storage.deleteOcultarOpcaoMenuBanco()
  dispatch('ActionSetAlertaStatusEmpresa', null)
  storage.deleteAlertaStatusEmpresa()
}
